import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { ApiService } from '../../api/api.service';
import { FormactionService } from '../../api/formaction.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-criview',
  templateUrl: './criview.component.html',
  styleUrls: ['./criview.component.css']
})
export class CriviewComponent implements OnInit {

  public trackId_name: string = ' ';
  public trackId_refno: string = ' ';
  public trackId_regno: string = ' ';
  public trackId_iticode: string = ' ';
  public trackId_trade: string = ' ';
  public trackId_state: string = ' ';
  public trackId_district: string = ' ';
  public trackId_date: string = ' ';
  public trackId_shift: string = ' ';
  public trackId_attendance: string = ' ';
  public trackId_status: string = ' ';
  public trackId_ntef: string = ' ';
  public trackId_issuedetail: string = ' ';
  public trackId_description: string = ' ';
  public trackId_center: string = ' ';
  public trackId_admin_status: string = ' ';
  public trackId_admin_status_desc: string = ' ';
  public trackId_inviginame: string = ' ';
  constructor(private formBuilder: FormBuilder, private api: ApiService, private formaction: FormactionService, private router: Router) { }

  ngOnInit(): void {


    this.formaction.get_criList_single().subscribe((result: any) => {
      var args = {
        eriNo: result.refno
      }



      this.api.trackIdCriview(args).subscribe((result: any) => {
        console.log("View: " + JSON.stringify(result));
        this.trackId_inviginame = result.invgname;
        this.trackId_name = result.username;
        this.trackId_refno = result.refno;
        this.trackId_regno = result.regno;
        this.trackId_iticode = result.iticode;
        this.trackId_trade = result.trade;
        this.trackId_state = result.state;
        this.trackId_district = result.district;
        this.trackId_date = result.date;
        this.trackId_shift = result.shift;
        this.trackId_center = result.center;
        this.trackId_attendance = result.attendance;
        this.trackId_status = result.status;
        this.trackId_ntef = result.ntef;
        this.trackId_issuedetail = result.issuedetail;
        this.trackId_description = result.description;
        this.trackId_admin_status = result.admin_status;
        this.trackId_admin_status_desc = result.admin_status_description;

      });
    });
  }

}
